// Get the data from localstorage
let data = (localStorage.getItem('eir_be_data')) ? (JSON.parse(localStorage.getItem('eir_be_data')).order) : '';
let bundle = (localStorage.getItem('eir_be_data')) ? (JSON.parse(localStorage.getItem('eir_be_data')).order.bundle) : '';

// function to check r6key contains MBB
const containsMBB = () => {
    if (bundle && bundle.plan && bundle.plan.r6Key === 'RT_BUNDLE_MOBILE_STANDALONE') {
        if (bundle && bundle.mobiles[0] && bundle.mobiles[0].plan && bundle.mobiles[0].plan.r6Key && bundle.mobiles[0].plan.r6Key.contains('MBB')) return true;
        else false
    }
}

// Get plan category for eCommerce
const getPlanCategory = (brand) => {
    if (brand === 'Bundles') {
        if (bundle.broadband &&
            bundle.voice &&
            bundle.mobiles.length > 0 &&
            bundle.tv) {
            return '4P';
        } else if (bundle.broadband &&
            bundle.voice &&
            bundle.tv) {
            return '3P IPTV';
        } else if (bundle.broadband &&
            bundle.voice &&
            bundle.mobiles.length > 0) {
            return '3P MOBILE';
        } else if (bundle.broadband &&
            bundle.mobiles.length > 0 &&
            bundle.tv) {
            return '3P NO VOICE';
        } else if (bundle.broadband &&
            bundle.tv) {
            return '2P IPTV';
        } else if (bundle.broadband &&
            bundle.mobiles.length > 0) {
            return '2P MOBILE';
        } else if (bundle.broadband &&
            bundle.voice) {
            return '2P VOICE';
        }
    } else {
        if (bundle && bundle.mobiles && bundle.mobiles.length > 0) {
            if (bundle.mobiles[0].plan.planType === 'BILLPAY') {
                if (bundle.mobiles[0].plan.simOnly) {
                    return 'SIM Only Plan'
                }
                return 'Bill Pay Plan'
            }
            if (bundle.mobiles[0].plan.planType === 'PREPAY') {
                return 'Prepay Plan'
            }
        }

        //Landline only (fixed voice)
        if (bundle && bundle.voice) {
            if (bundle.voice.plan.type === 'POTS') {
                return 'Fixed Voice';
            }
        }

        //Broadband plan
        if (bundle && bundle.broadband) {
            switch (bundle.broadband.plan.type) {
                case 'FTH':
                case 'FTC':
                    return 'NGA';
                case 'NGB':
                    return 'NGB';
                case 'DSL':
                    return 'DSL';
            }
        }
    }
}

// Get all plan names in cart for eCommerce
const getPlanNames = () => {

    let planNames = '';
    if (bundle && bundle.broadband) {
        planNames += ' + '.concat(bundle.broadband.plan.name);
    } if (bundle && bundle.voice) {
        planNames += ' + '.concat(bundle.voice.plan.name);
    } if (bundle && bundle.tv) {
        planNames += ' + '.concat(bundle.tv.plan.name);
    } if (bundle && bundle.mobiles) {
        for (let i in bundle.mobiles) {
            planNames += ' + '.concat(bundle.mobiles[i].plan.name);
        }
    }

    if (planNames.startsWith(' + ') == true) {
        planNames = planNames.substring(3);
    }
    return planNames;
}

// Get R6 keys for all plans in cart for eCommerce
const getPlanR6Keys = () => {

    let planR6Keys = '';
    if (bundle && bundle.broadband) {
        planR6Keys += ' + '.concat(bundle.broadband.plan.r6Key);
    } if (bundle && bundle.voice) {
        planR6Keys += ' + '.concat(bundle.voice.plan.r6Key);
    } if (bundle && bundle.tv) {
        planR6Keys += ' + '.concat(bundle.tv.plan.r6Key);
    } if (bundle && bundle.mobiles) {
        for (let i in bundle.mobiles) {
            planR6Keys += ' + '.concat(bundle.mobiles[i].plan.r6Key);
        }
    }

    if (planR6Keys.startsWith(' + ') == true) {
        planR6Keys = planR6Keys.substring(3);
    }
    return planR6Keys;
}

// Get brand details for eCommerce
const getBrand = () => {
    switch (bundle && bundle.plan && bundle.plan.r6Key) {
        case 'RT_BUNDLE_MBB_STANDALONE':
            return 'Mobile Broadband';
            break;
        case 'RT_BUNDLE_MOBILE_STANDALONE':
            if (containsMBB)
                return 'Mobile Broadband';
            else
                return 'Mobile';
            break;
        case 'RT_BUNDLE_FV_STANDALONE':
            return 'Landline';
            break;
        case 'RT_BUNDLE_NGA_STANDALONE':
        case 'RT_BUNDLE_NGB_SABB':
            return 'Broadband Only';
            break;
        default:
            return 'Bundles';
    }
}

const getDeviceCategory = () => {
    //Mobile or SIM or dongle
    if (bundle && bundle.mobiles[0]) {
        if (bundle.mobiles[0].plan.planType == 'BILLPAY') {
            return 'Bill Pay Device'
        }
        if (bundle.mobiles[0].plan.planType == 'PREPAY') {
            return 'Prepay Device'
        }
    }
}

const getOrderTotal = () => {
    let orderContractLength;
    if (bundle && bundle.plan && bundle.plan.defaultContract) { orderContractLength = bundle.plan.defaultContract.contractLength }
    else if (bundle && bundle.contract) { orderContractLength = bundle.contract.contractLength }
    else { orderContractLength = 0 }

    // (Contract Length in Months * Monthly Cost) - (Discount Length in Months * Monthly Discount Amount)
    return ((orderContractLength * data.totalMonthlyCost) - (data.longestPromotionLength * data.promoDiscount));
}

// Construct and populate products to push to GA
const getOrderProducts = () => {

    let products = [];
    let brand = getBrand();

    //All plans
    products.push({
        'brand': brand,
        'category': getPlanCategory(brand),
        'name': getPlanNames(),
        'id': getPlanR6Keys(),
        'price': getOrderTotal(),
        'quantity': 1
    });

    //If this bundle has a device - Mobile handset or SIM or MBB dongle
    if (data && data.bundle && data.bundle.mobiles && data.bundle.mobiles.length > 0) {
        for (let i in data.bundle.mobiles) {
            let mobile = data.bundle.mobiles[i];
            if (mobile.handset) {
                products.push({
                    'brand': brand,
                    'category': getDeviceCategory(),
                    'name': mobile.handset.name,
                    'id': mobile.handset.variant.name,
                    'price': mobile.handsetPrice,
                    'quantity': 1
                });
            }
        }
    }

    //If this bundle has addons
    if (bundle && bundle.tv) {
        for (let i in bundle.tv.addOns) {
            products.push({
                'brand': 'Add-Ons',
                'category': 'TV',
                'name': data.bundle.tv.addOns[i].name,
                'id': data.bundle.tv.addOns[i].r6Key,
                'price': 0, //price will be covered in order total
                'quantity': 1
            });
        }
    }
    return products;
}

const pushOrder = () => {

    // push datalayer
    dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
            'purchase': {
                'actionField': {
                    'id': data && data.id,
                    'affiliation': 'Springboard Online Sales'
                },
                'products': getOrderProducts()
            }
        }
    });

    dataLayer.push({
        'transactionId': data && data.id,
        'transactionAffiliation': 'Springboard Online Sales',
        'transactionProducts': getOrderProducts(),
        'transactionContractLength': bundle && bundle.contract.contractLength,
        'transactionMonthlyCost': data && data.totalMonthlyCost,
        'transactionDiscountLength': data && data.longestPromotionLength,
        'transactionMonthlyDiscountAmount': data && data.promoDiscount,
        'transactionOnceOffPayment': data && data.totalAdvancePayment,
        'transactionTotal': getOrderTotal(),
        'event': 'transaction_ready'
    });
}

//push checkout data layer for customer-details, installation-details, payment-details
const pushCheckoutEvent = (param) => {
    dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
            'checkout': {
                'actionField': param,
                'products': getOrderProducts()
            }
        }
    });
}

//push order confirmation data layer
const pushTransactionReadyEvent = () => {
    dataLayer.push({
        'event': 'transaction_ready',
        'ecommerce': {
            'currency': 'EUR',
            'purchase': {
                'actionField': {
                    'id': data && data.id,
                    'affiliation': 'Springboard Online Sales'
                },
                'products': getOrderProducts()
            }
        }
    });
}

//push event for support site accordion tracking
const pushAccordionTrackEvent = (accordionTitle, url) => {
    dataLayer.push({
                     'event': 'support-article',    
                     'article-title': accordionTitle,         
                     'url': url         
    });
}

export { pushOrder, pushCheckoutEvent, pushTransactionReadyEvent, pushAccordionTrackEvent};